export default __webpack_public_path__ + "static/media/impacto_logo_blanco.907821ea.png";